/**
 * Login Divider Component
 *
 * Horizontal divider with centered text for login page.
 */

import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import { memo } from 'react';

interface LoginDividerProps {
  text?: string;
}

export const LoginDivider = memo(function LoginDivider({
  text = 'or',
}: LoginDividerProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        my: 3,
      }}
    >
      <Divider sx={{ flex: 1 }} />
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ px: 2, textTransform: 'uppercase', fontSize: '0.75rem', letterSpacing: 1 }}
      >
        {text}
      </Typography>
      <Divider sx={{ flex: 1 }} />
    </Box>
  );
});

